export const STATUS_META = {
  entwurf: { label: "Entwurf", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  angekauft: { label: "Angekauft", color: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  transport_ausstehend: { label: "Transport ausstehend", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  im_transport: { label: "Im Transport", color: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  angekommen: { label: "Angekommen", color: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  eingangskontrolle: { label: "Eingangskontrolle", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  werkstattpruefung: { label: "Werkstattprüfung", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  aufbereitung: { label: "Aufbereitung", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  fotografie: { label: "Fotografie", color: "bg-violet-400/15 text-violet-300 border-violet-400/30" },
  datenpruefung: { label: "Datenprüfung", color: "bg-orange-500/15 text-orange-300 border-orange-500/30" },
  preisfreigabe: { label: "Preisfreigabe", color: "bg-orange-500/15 text-orange-300 border-orange-500/30" },
  bereit: { label: "Veröffentlichungsbereit", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  veroeffentlicht: { label: "Veröffentlicht", color: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40" },
  reserviert: { label: "Reserviert", color: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  verkauft: { label: "Verkauft", color: "bg-slate-500/25 text-slate-300 border-slate-500/40" },
  ausgeliefert: { label: "Ausgeliefert", color: "bg-slate-500/25 text-slate-300 border-slate-500/40" },
  archiviert: { label: "Archiviert", color: "bg-slate-600/25 text-slate-400 border-slate-600/40" },
};

export const SIMPLE_STATUS_META = {
  entwurf: { label: "Entwurf", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  fotos: { label: "Fotos", color: "bg-violet-400/15 text-violet-300 border-violet-400/30" },
  pruefung: { label: "Prüfung", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  bereit: { label: "Veröffentlichungsbereit", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  online: { label: "Online", color: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40" },
  verkauft: { label: "Verkauft", color: "bg-slate-500/25 text-slate-300 border-slate-500/40" },
  archiviert: { label: "Archiviert", color: "bg-slate-600/25 text-slate-400 border-slate-600/40" },
};

export const AVAILABILITY_META = {
  sofort: { label: "Sofort verfügbar" },
  im_zulauf: { label: "Im Zulauf" },
  ab_datum: { label: "Verfügbar ab Datum" },
  besichtigung: { label: "Besichtigung n. Vereinbarung" },
  aufbereitung: { label: "Wird aufbereitet" },
};

export const FOTOBOOTH_TEMPLATES = [
  { key: "studio_hell", label: "Helles Studio", hint: "neutral, clean", swatch: "linear-gradient(160deg,#e8eaee 0%,#c9cdd4 100%)" },
  { key: "studio_dunkel", label: "Dunkles Premium-Studio", hint: "dramatische Reflexionen", swatch: "linear-gradient(160deg,#2a2f38 0%,#0d1117 100%)" },
  { key: "showroom", label: "Neutraler Showroom", hint: "weiches Tageslicht", swatch: "linear-gradient(160deg,#dfe5ea 0%,#aeb9c2 100%)" },
  { key: "beton", label: "Moderner Beton-Look", hint: "urban premium", swatch: "linear-gradient(160deg,#9aa1a8 0%,#6c737a 100%)" },
  { key: "weiss", label: "Weißer Hintergrund", hint: "börsen-optimiert", swatch: "linear-gradient(160deg,#ffffff 0%,#eef0f2 100%)" },
];

export const TRUST_META = {
  bestaetigt: { label: "Bestätigt", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  wahrscheinlich: { label: "Wahrscheinlich", color: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  manuell: { label: "Manuell", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  widerspruechlich: { label: "Widersprüchlich", color: "bg-red-500/15 text-red-300 border-red-500/30" },
  fehlt: { label: "Fehlt", color: "bg-slate-600/25 text-slate-400 border-slate-600/40" },
  pruefen: { label: "Prüfen", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
};

export const PUB_META = {
  draft: { label: "Entwurf", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  ready: { label: "Bereit", color: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  publishing: { label: "Wird übertragen", color: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  published: { label: "Online", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  update_pending: { label: "Update ausstehend", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  failed: { label: "Fehler", color: "bg-red-500/15 text-red-300 border-red-500/30" },
  paused: { label: "Pausiert", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
  removed: { label: "Entfernt", color: "bg-slate-600/25 text-slate-400 border-slate-600/40" },
  sold: { label: "Verkauft", color: "bg-slate-600/25 text-slate-400 border-slate-600/40" },
};

export const COMPLIANCE_META = {
  ready: { label: "Veröffentlichungsbereit", color: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  ready_with_warnings: { label: "Bereit mit Warnungen", color: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  confirmation_required: { label: "Bestätigung erforderlich", color: "bg-orange-500/15 text-orange-300 border-orange-500/30" },
  blocked: { label: "Blockiert", color: "bg-red-500/15 text-red-300 border-red-500/30" },
};

export const ROLE_LABELS = {
  owner: "Inhaber", manager: "Manager", einkauf: "Einkauf",
  aufbereitung: "Aufbereitung", verkauf: "Verkauf", fotograf: "Fotograf / Content",
};

export const SOURCE_LABELS = {
  vin_provider: "VIN-Provider", fahrzeugschein: "Fahrzeugschein", haendlerangabe: "Händlerangabe",
  foto_ki: "Foto-KI", dokument_ki: "Dokument-KI", manuell: "Manuell", extern: "Extern", dealalert: "DealAlert",
};

export const FIELD_LABELS = {
  marke: "Marke", modell: "Modell", modellfamilie: "Modellfamilie", generation: "Generation",
  variante: "Variante", interne_bezeichnung: "Interne Bezeichnung", baujahr: "Baujahr", modelljahr: "Modelljahr",
  erstzulassung: "Erstzulassung", karosserie: "Karosserieform", motor: "Motor", hubraum_ccm: "Hubraum (ccm)",
  leistung_kw: "Leistung (kW)", leistung_ps: "Leistung (PS)", kraftstoff: "Kraftstoff", getriebe: "Getriebe",
  antrieb: "Antrieb", emissionsklasse: "Emissionsklasse", verbrauch_kombiniert: "Verbrauch kombiniert",
  co2_g_km: "CO₂ (g/km)", tueren: "Türen", sitze: "Sitzplätze", farbe_aussen: "Außenfarbe", farbe_innen: "Innenfarbe",
  leergewicht_kg: "Leergewicht (kg)", gesamtgewicht_kg: "Zul. Gesamtgewicht (kg)", anhaengelast_kg: "Anhängelast (kg)",
  hsn_tsn: "HSN/TSN", kilometerstand: "Kilometerstand", vorbesitzer: "Vorbesitzer", zustand: "Zustand",
  standort: "Standort", zustand_aussen: "Zustand außen", zustand_innen: "Zustand innen",
  schluessel_anzahl: "Anzahl Schlüssel", service_status: "Servicestatus", unfallstatus: "Unfallstatus",
  zusatzraeder: "Zusatzräder", nichtraucher: "Nichtraucher", sonstiges: "Sonstiges",
};

export const CLAIM_TYPE_LABELS = {
  unfallstatus: "Unfallstatus", scheckheft: "Scheckheft", kilometerstand_garantiert: "Kilometerstand",
  erste_hand: "Erste Hand", nichtraucher: "Nichtraucher", nachlackierung: "Nachlackierung",
  technisch_einwandfrei: "Technischer Zustand", maengelfrei: "Mängelfreiheit", mwst_ausweisbar: "MwSt.-Status",
  garantie: "Garantie", gewaehrleistung: "Gewährleistung", import: "Import", vorbesitzer: "Vorbesitzer",
  originalkilometer: "Originalkilometer", schluessel: "Schlüssel", service: "Service", zusatzraeder: "Zusatzräder",
  schaden: "Schaden", aufbereitung: "Aufbereitung",
};

export const SALES_CHANNELS = [
  { key: "mobile_de", label: "mobile.de" },
  { key: "autoscout24", label: "AutoScout24" },
  { key: "homepage", label: "Eigene Homepage" },
  { key: "direktverkauf", label: "Direktverkauf" },
  { key: "b2b", label: "B2B-Händler" },
  { key: "export", label: "Export" },
  { key: "auktion", label: "Auktion" },
  { key: "social_media", label: "Social Media" },
  { key: "sonstiges", label: "Sonstiges" },
];
export const SALES_CHANNEL_LABELS = Object.fromEntries(SALES_CHANNELS.map((c) => [c.key, c.label]));

export const fmtEUR = (v) =>
  v == null ? "–" : new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);

export const fmtKm = (v) => (v == null ? "–" : new Intl.NumberFormat("de-DE").format(v) + " km");

export const fmtDate = (iso) => {
  if (!iso) return "–";
  try {
    return new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "–";
  try {
    return new Date(iso).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};
